import { useCookies } from 'react-cookie';
import CookieConfig from 'utils/CookieConfig';
import LocalStorageUtils from 'utils/LocalStorage';

const COOKIE_OPTIONS = {
   maxAge: 21600,
   path: '/',
   domain: '.sinarmasmsiglife.co.id'
}
export default function useCookieHook() {
   const [authCookie, setAuthCookie, removeCookie] = useCookies([ CookieConfig.auth_id ]);


   const initalAuthCookie = () => {
      setAuthCookie( CookieConfig.auth_id, LocalStorageUtils.jwtToken.get(), COOKIE_OPTIONS)
   }

   const removeAuthCookie = () => {
      removeCookie(CookieConfig.auth_id, COOKIE_OPTIONS)
   }

   return {
    authCookie,
    initalAuthCookie,
    removeAuthCookie
   }
}
